import React from 'react'
import {Helmet} from 'react-helmet'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

function Fonts() {
    return (
        <Helmet>
            {/* Preconnect to Google Fonts and Cavenders CDN to speed up font/asset loading */}
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
            <link rel="preconnect" href="https://assets.cavenders.com" crossOrigin="anonymous" />

            <link
                rel="preload"
                href={getAssetUrl('static/fonts/webfonts/Montserrat-latin.woff2')}
                as="font"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <link
                rel="preload"
                href={getAssetUrl('static/fonts/webfonts/Libre-Franklin-latin.woff2')}
                as="font"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <link href={getAssetUrl('static/fonts/fonts.css')} rel="stylesheet" />
        </Helmet>
    )
}

export default Fonts
